import { render, staticRenderFns } from "./AboutMain.vue?vue&type=template&id=13d18ec8&scoped=true"
import script from "./AboutMain.vue?vue&type=script&lang=js"
export * from "./AboutMain.vue?vue&type=script&lang=js"
import style0 from "./AboutMain.vue?vue&type=style&index=0&id=13d18ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d18ec8",
  null
  
)

export default component.exports